<template>
  <div class="container-fluid">
    <div class="row">
      <div
        class="col-xl-7 order-1 b-center bg-size"
        :style="{
          backgroundImage: `url(${fondoLogin})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'round',
        }"
      >
        <img
          class="bg-img-cover bg-center"
          style="display: none"
          src="@/assets/images/login/SK-login-bg.jpg"
          alt="looginpage"
        />
      </div>
      <div class="col-xl-5 p-0">
        <div class="login-card">
          <div>
            <div>
              <a class="logo text-center"
                ><router-link to="/">
                  <img
                    class="img-fluid for-light"
                    src="@/assets/images/logo/logo-SK.png"
                    alt="looginpage" /></router-link
              ></a>
            </div>
            <div class="login-main">
              <form class="theme-form" novalidate @submit.prevent="handleLogin">
                <h4 class="text-center">Iniciar sesión</h4>
                <p class="text-center">Ingresa tu email y contraseña para continuar</p>

                <!-- Mensaje de error global -->
                <div v-if="errorMessage" class="alert alert-danger" role="alert">
                  <vue-feather type="alert-circle" size="16"></vue-feather>
                  {{ errorMessage }}
                </div>

                <div class="form-group">
                  <label class="col-form-label">Email</label>
                  <input
                    class="form-control"
                    :class="formSubmitted ? (emailError ? 'is-invalid' : 'is-valid') : ''"
                    id="email"
                    v-model="email"
                    type="email"
                    required
                    placeholder="email@ejemplo.com"
                    :disabled="loading"
                  />
                  <div v-if="formSubmitted && emailError" class="invalid-feedback">
                    Por favor ingresa un email válido
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-form-label">Contraseña</label>
                  <div class="password-input-wrapper">
                    <input
                      class="form-control"
                      :class="formSubmitted ? (passwordError ? 'is-invalid' : 'is-valid') : ''"
                      :type="showPassword ? 'text' : 'password'"
                      required
                      placeholder="*********"
                      v-model="password"
                      :disabled="loading"
                    />
                    <button
                      type="button"
                      class="password-toggle-btn"
                      @click="showPassword = !showPassword"
                      :disabled="loading"
                      tabindex="-1"
                    >
                      <vue-feather :type="showPassword ? 'eye-off' : 'eye'" size="18"></vue-feather>
                    </button>
                  </div>
                  <div v-if="formSubmitted && passwordError" class="invalid-feedback">
                    La contraseña es requerida
                  </div>
                </div>

                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" type="checkbox" v-model="rememberPassword" />
                    <label class="text-muted" for="checkbox1">Recordar contraseña</label>
                  </div>
                  <a class="link">
                    <router-link to="/authentication/forgetpassword"
                      >¿Olvidaste tu contraseña?</router-link
                    >
                  </a>
                  <div class="text-end mt-3">
                    <button
                      class="btn btn-primary btn-block w-100"
                      type="submit"
                      :disabled="loading"
                    >
                      <span
                        v-if="loading"
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span v-if="loading">Iniciando sesión...</span>
                      <span v-else>Iniciar sesión</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validateSessionAgainstRTDB, getUserAccessMessage } from '@/utils/sessionGuard'
import fondoLogin from '../../assets/images/login/SK-login-bg.jpg'

export default {
  name: 'LoginValidation',
  data() {
    return {
      email: '',
      password: '',
      formSubmitted: false,
      emailError: false,
      passwordError: false,
      rememberPassword: false,
      errorMessage: '',
      loading: false,
      showPassword: false,
      fondoLogin,
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoading']),
  },
  methods: {
    ...mapActions('auth', ['login', 'forceLogout']),

    showStoredLogoutMessage() {
      const message = sessionStorage.getItem('auth_logout_message')
      const reason = this.$route.query.reason || sessionStorage.getItem('auth_logout_reason')

      if (message) {
        this.errorMessage = message
        sessionStorage.removeItem('auth_logout_message')
        sessionStorage.removeItem('auth_logout_reason')
        return
      }

      if (reason) {
        this.errorMessage = getUserAccessMessage(reason)
      }
    },

    validateForm() {
      this.errorMessage = ''
      this.emailError = false
      this.passwordError = false

      // Validar email
      if (!this.email || this.email.length < 10 || this.email.search('@') === -1) {
        this.emailError = true
        return false
      }

      // Validar password
      if (!this.password || this.password.length < 6) {
        this.passwordError = true
        return false
      }

      return true
    },

    async handleLogin() {
      this.formSubmitted = true

      // Validar formulario
      if (!this.validateForm()) {
        this.errorMessage = 'Por favor corrige los errores en el formulario'
        return
      }

      // Limpiar mensajes anteriores
      this.errorMessage = ''
      this.loading = true

      try {
        // Llamar a la acción de login del store
        const result = await this.login({
          email: this.email.trim(),
          password: this.password,
        })

        if (result.success) {
          // Redirigir según el rol del usuario
          const user = this.$store.getters['auth/currentUser']
          const userRole = user?.rol
          const limitedRoles = ['Servicio a Domicilio', 'Transportista']

          // Roles limitados se redirigen a pedidos
          if (limitedRoles.includes(userRole)) {
            this.$router.push('/pedidos')
          } else {
            // Para cualquier otro rol, redirigir al dashboard
            this.$router.push('/dashboard')
          }
        } else {
          // Mostrar mensaje de error
          this.errorMessage = result.error || 'Error al iniciar sesión. Por favor intenta de nuevo.'
        }
      } catch (error) {
        console.error('Error in handleLogin:', error)
        this.errorMessage = 'Error inesperado al iniciar sesión. Por favor intenta de nuevo.'
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    this.showStoredLogoutMessage()

    if (!this.$store.getters['auth/isAuthenticated']) {
      return
    }

    const user = this.$store.getters['auth/currentUser']
    const sessionCheck = await validateSessionAgainstRTDB(user?.uid)

    if (!sessionCheck.valid) {
      await this.forceLogout({
        reason: sessionCheck.reason,
        internalDetail: sessionCheck.internalDetail,
        redirect: false,
      })
      this.errorMessage = getUserAccessMessage(sessionCheck.reason)
      return
    }

    const userRole = user?.rol
    const limitedRoles = ['Servicio a Domicilio', 'Transportista']

    if (limitedRoles.includes(userRole)) {
      this.$router.push('/pedidos')
    } else {
      this.$router.push('/dashboard')
    }
  },
}
</script>

<style lang="scss" scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}

.alert {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.password-input-wrapper {
  position: relative;
}

.password-input-wrapper .form-control {
  padding-right: 45px;
}

.password-toggle-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.password-toggle-btn:hover:not(:disabled) {
  color: #495057;
}

.password-toggle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.password-toggle-btn:focus {
  outline: none;
  box-shadow: none;
}

/* Estilos para modo oscuro */
:deep(body.dark-only) .password-toggle-btn {
  color: rgba(255, 255, 255, 0.6);
}

:deep(body.dark-only) .password-toggle-btn:hover:not(:disabled) {
  color: rgba(255, 255, 255, 0.8);
}
</style>
